import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconStravaBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStravaBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '46d5cad4dd7e41a6e42bb2a6a66266c6b6895b6e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6d94da6a162a6af6b6cbb2fdfbd832b825fbb041', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ddac431e52ca63155f91765377ba2cf1570b8a52', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m14.099 15.7-1.652-3.254h-2.423l4.075 8.042 4.073-8.042h-2.426", fill: "#F9B797" }), h("path", { key: 'b239f6c708ea01e3a70fde75ac1a1a4c8d56785d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.206 8.018 2.242 4.426h3.299L10.206 1.512 4.672 12.446h3.296", fill: "#F05222" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-strava-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-strava-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-strava-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStravaBranded$1);
            }
            break;
    } });
}

const CosmosIconStravaBranded = CosmosIconStravaBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStravaBranded, defineCustomElement };
